// default export can be imported by any name in another file, whatever name u give it there will export the default function as that
// new name
import EScoreType from 'enums/EScoreType';
import {
  SET_WELLDETAILS,
  SET_SELECTEDCELL,
  SET_GLOBALDATELOADED,
  SET_CURRENT_WELL_SCORES,
  SET_SCORING_WELL,
  SET_IMAGE_TUNING,
  EXP_DATA_UPDATED,
} from 'redux/actions/plateAction';
import { GetExpInspections, isNullOrUndefined } from 'utils/Global';

export const INTRESTINGSCOREID = 11;

export default function plateReducer(state = [], action) {
  switch (action.type) {
    case SET_SELECTEDCELL:
      return { ...state, selectedCell: action.selectedCell };

    case SET_WELLDETAILS:
      return { ...state, welldetails: action.welldetails };

    case SET_CURRENT_WELL_SCORES:
      return { ...state, currentWellScores: action.currentWellScores };

    case SET_GLOBALDATELOADED:
      return { ...state, globaldataloaded: true };

    case SET_SCORING_WELL:
      const currWellScores = isNullOrUndefined(state.currentWellScores)
        ? []
        : state.currentWellScores;
      let allInspectionsScores = [...currWellScores];
      const {
        wellNumber,
        wellDropScoreGroupId,
        imageBatchId,
        dropNumber,
        isDeleteScore,
        wellDropScoreId,
      } = action.screWell || {};
      const allScoreIndex = allInspectionsScores.findIndex(
        (wds) =>
          wds.wellNumber === wellNumber &&
          wds.wellDropScoreGroupId === wellDropScoreGroupId &&
          wds.scoreBatchId === imageBatchId &&
          wds.dropNumber === dropNumber,
      );
      let scoreObj = [];
      if (wellDropScoreGroupId === INTRESTINGSCOREID && !isDeleteScore) {
        const inspections = GetExpInspections();
        const dropInspections = [];
        inspections.forEach((inspection) => {
          inspection.groupedInspections.forEach((gi) =>
            dropInspections.push(gi.imageBatchId),
          );
        });
        const uniqueInspections = [...new Set(dropInspections)];
        uniqueInspections.forEach((di) =>
          scoreObj.push({
            wellNumber: wellNumber,
            wellDropScoreId: wellDropScoreId,
            wellDropScoreGroupId: wellDropScoreGroupId,
            isAutoScore: false,
            scoreBatchId: di,
            dropNumber: dropNumber,
            scoreType: EScoreType.Manual,
          }),
        );
      } else {
        scoreObj = [
          {
            wellNumber: wellNumber,
            wellDropScoreId: wellDropScoreId,
            wellDropScoreGroupId: wellDropScoreGroupId,
            isAutoScore: false,
            scoreBatchId: imageBatchId,
            dropNumber: dropNumber,
            scoreType: EScoreType.Manual,
          },
        ];
      }
      if (isDeleteScore && wellDropScoreGroupId === INTRESTINGSCOREID) {
        allInspectionsScores = allInspectionsScores.filter(
          (scores) =>
            scores.wellDropScoreGroupId !== INTRESTINGSCOREID ||
            scores.dropNumber !== dropNumber,
        );
      } else if (isDeleteScore && allScoreIndex !== -1) {
        allInspectionsScores.splice(allScoreIndex, 1);
      } else if (!isDeleteScore && wellDropScoreGroupId === INTRESTINGSCOREID) {
        allInspectionsScores = [...allInspectionsScores, ...scoreObj];
      } else if (allScoreIndex === -1) {
        // If selected well have scores from other score groups but not from the scoregroup which we have scored so it will be added in that well scores
        allInspectionsScores.push(scoreObj[0]);
      } else if (allScoreIndex !== -1) {
        allInspectionsScores.splice(allScoreIndex, 1, scoreObj[0]);
      }
      return {
        ...state,
        scoringWell: state.scoringWell !== undefined ? !state.scoringWell : true,
        currentWellScores: allInspectionsScores,
      };
    case SET_IMAGE_TUNING:
      return { ...state, imageTuning: action.imageTuning };
    case EXP_DATA_UPDATED:
      return { ...state, expData: action.expData };
    default:
      return state; // return state as default in all reducers as othere will need state
  }
}
